const invoices = {
    state: {
        invoices: []
    },

    mutations: {
        invoicesUpdate: function (state, payload) {
            state.invoices = payload;
        },
    },
    actions: {
        updateInvoices: function (context) {
            window.api.get('my-account/invoices-history')
                .then(response => {
                    context.commit('invoicesUpdate', response.data.data[0] || [])
                })
                .catch(() => {
                    context.commit('invoicesUpdate', [])
                })
        },
    },
    getters: {
        getInvoices: function (state) {
            return state.invoices;
        },
    }
}

export default invoices;
